module.exports = __webpack_public_path__ + "img/azaka_no.d7b3d3d5.png";